export const ACTIONS = {
  RECORD_SYSTEM_HEALTH_CHECK_EVENT: 'RECORD_SYSTEM_HEALTH_CHECK_EVENT',
};

export const recordSystemHealthCheck = data => dispatch => {
  dispatch({
    type: ACTIONS.RECORD_SYSTEM_HEALTH_CHECK_EVENT,
    payload: data,
  });
};
